import { Component,  Inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ConfirmDialogTicket } from './confirmDialogTicket';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'confirm-dialog-ticket',
  templateUrl: './confirm-dialog-ticket.component.html',
  styleUrls: ['./confirm-dialog-ticket.component.scss']
})
export class ConfirmDialogTicketComponent {


  documento:any;

  constructor(public dialogConfirm: MatDialogRef<ConfirmDialogTicketComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogTicket,
    private _sanitizationService: DomSanitizer) {  

      if(this.data.wr){
        this.documento = this.data.wr.ticket;
      }
      
      if(this.data.quote){
        this.documento = this.data.quote.url_quote;
      }

      this.documento = this._sanitizationService.bypassSecurityTrustResourceUrl(environment.apiEndpoint+'ajax/'+this.documento);
      
     }

  ngOnInit() {
  }
  closeConfirmDialog(){
    this.dialogConfirm.close();
  }
  confirmDialog(){
    this.data.flagRespuesta = true;
    this.dialogConfirm.close(this.data); 
  }
}